import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent {
@Input() control: FormControl
@Input() type: string
@Input() customStyle: string
// ngOnInit() {
//   console.log("control",this.control);
  
// }
}
